import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiChannel } from 'core/constants';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { StoreAction } from 'store/actions';
import { LineLockStatus } from './models';

@Injectable()
export class MdnLockAPI {
    public static getLineLockStatus(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<LineLockStatus> {
        return http.get(`/lines/mdnlock/status?idType=LINE_ID_KEY&idValue=${params.lineId}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: LineLockStatus) => LineLockStatus.create<LineLockStatus>(response))
        );
    }

    public static enableLineLock(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<LineLockStatus> {
        return http.post('/lines/mdnlock/enable', params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: LineLockStatus) => LineLockStatus.create<LineLockStatus>(response))
        );
    }

    public static disableLineLock(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<LineLockStatus> {
        return http.post('/lines/mdnlock/disable', params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: LineLockStatus) => LineLockStatus.create<LineLockStatus>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_LINE_LOCK_STATUS] = MdnLockAPI.getLineLockStatus;
ModelBase.persistMapping[StoreAction.POST_ENABLE_LINE_LOCK] = MdnLockAPI.enableLineLock;
ModelBase.persistMapping[StoreAction.POST_DISABLE_LINE_LOCK] = MdnLockAPI.disableLineLock;
